<div app-layout>
  <div *ngIf="!form.value.id; else hasId" class="flex h-full flex-col items-center justify-center">
    <svg-icon
      class="flex h-[58px] w-[58px] justify-center font-bold text-theme-500"
      src="assets/icons/icon-vector.svg"
    ></svg-icon>
    <p class="text-theme-500" translate>
      <span class="px-2 align-middle text-xl text-theme-500">←</span>trilhas.estudio.trilha.texto-cadastro
    </p>
  </div>
</div>
<ng-template #hasId>
  <div
    *ngIf="!learningTrailsSectionService.sections$.value?.length; else hasSection"
    class="flex h-full flex-col items-center justify-center"
  >
    <p class="pb-10 text-md text-theme-500" translate>trilhas.estudio.trilha.texto-sem-secao</p>
    <div class="flex items-center justify-end">
      <button
        type="button"
        app-icon-button
        translate
        (click)="onAddSection()"
        class="group mx-2 border border-theme-800 text-theme-800 shadow-md hover:bg-theme-500 hover:text-theme-contrast"
      >
        <svg-icon
          class="mr-2 flex w-5 justify-center text-theme-800 group-hover:text-theme-contrast"
          src="assets/icons/icon-plus.svg"
        ></svg-icon>
        trilhas.estudio.trilha.secao
      </button>
    </div>
  </div>
  <ng-template #hasSection>
    <div class="h-full py-7">
      <div class="flex items-center justify-between pb-14">
        <h1 translate class="text-xl font-bold text-theme-950">trilhas.estudio.trilha.elementos-trilha</h1>
        <div class="flex items-center justify-end">
          <ng-container *ngIf="hasElements$ | async">
            <button
              *ngIf="preview$ | async as preview"
              [routerLink]="preview"
              type="button"
              app-icon-button
              translate
              class="group mx-2 border border-theme-800 uppercase text-theme-800 shadow-md duration-300 hover:bg-theme-800 hover:text-theme-contrast"
            >
              <svg-icon
                class="mr-2 flex w-6 justify-center text-theme-800 duration-300 group-hover:text-theme-contrast"
                src="assets/icons/icon-view.svg"
              ></svg-icon>
              trilhas.estudio.pre-visualizacao
            </button>
          </ng-container>
          <button
            type="button"
            app-icon-button
            translate
            (click)="onAddSection()"
            class="group mx-2 border border-theme-800 uppercase text-theme-800 shadow-md duration-300 hover:bg-theme-800 hover:text-theme-contrast"
          >
            <svg-icon
              class="mr-2 flex w-4 justify-center text-theme-800 duration-300 group-hover:text-theme-contrast"
              src="assets/icons/icon-more.svg"
            ></svg-icon>
            trilhas.estudio.trilha.secao
          </button>
        </div>
      </div>
      <div
        cdkDropList
        #sectionsList="cdkDropList"
        [cdkDropListData]="learningTrailsSectionService.sections$"
        (cdkDropListDropped)="dropSection($event)"
        class="flex w-full flex-col"
      >
        <div
          *ngFor="
            let section of learningTrailsSectionService.sections$ | async;
            let i = index;
            let first = first;
            let last = last
          "
          class="group/section relative mb-16 flex w-full flex-col items-center justify-start rounded-lg border border-theme-500 p-10"
          cdkDrag
        >
          <div>
            <div
              class="absolute -top-8 left-5 flex w-6/12 items-center justify-start rounded-full bg-theme-500 p-4 pr-8"
            >
              <svg-icon
                cdkDragHandle
                class="ml-1 mr-1 hidden w-6 cursor-move justify-center text-theme-50 md:flex"
                src="assets/icons/icon-grid.svg"
              ></svg-icon>
              <div class="mr-1 md:hidden">
                <svg-icon
                  *ngIf="!first"
                  (click)="moveUpSection(section)"
                  class="mb-1 flex w-3"
                  src="assets/icons/icon-arrow-up.svg"
                ></svg-icon>
                <svg-icon
                  *ngIf="!last"
                  (click)="moveDownSection(section)"
                  class="flex w-3"
                  src="assets/icons/icon-arrow-down.svg"
                ></svg-icon>
              </div>
              <div class="w-full text-lg text-theme-contrast">
                <input
                  [id]="i"
                  class="hover:boder h-10 w-full rounded-md border-0 bg-transparent text-md text-opacity-0 placeholder:text-gray-300 hover:border-gray-400 focus:border-gray-400 focus:ring-gray-400"
                  type="text"
                  (change)="onChangeTitleSection(section, $event?.target?.value)"
                  [placeholder]="'geral.titulo' | translate"
                  [value]="section.titulo"
                />
              </div>
              <label class="cursor-pointer" [for]="i">
                <svg-icon
                  class="ml-4 flex w-6 justify-end text-theme-50 duration-300 md:hidden md:group-hover/section:flex"
                  src="assets/icons/icon-pencil.svg"
                ></svg-icon>
              </label>
            </div>
            <div
              class="group absolute -top-5 right-5 mr-8 flex justify-center opacity-0 group-hover/section:opacity-100 xl:mr-24"
            >
              <button
                translate
                *ngIf="section.id"
                type="button"
                app-tooltip
                (click)="onOpenElementModal(section.id, section.elementos.length)"
                [tooltip]="'trilhas.estudio.trilha.add-elemento' | translate"
                class="rounded-full bg-[#fafafa] p-2 shadow-md ring-1 ring-theme-500 duration-300 hover:ring-4 hover:ring-theme-200 group-hover/section:bg-theme-800"
              >
                <svg-icon
                  class="flex w-6 p-1 text-theme-500 group-hover/section:text-theme-50"
                  src="assets/icons/icon-plus.svg"
                ></svg-icon>
              </button>
              <button
                *ngIf="!section?.elementos?.length"
                translate
                type="button"
                app-tooltip
                (click)="onDeleteSection(section, i)"
                [tooltip]="'trilhas.estudio.trilha.excluir-elemento' | translate"
                class="ml-5 rounded-full bg-[#fafafa] p-2 shadow-md ring-1 ring-theme-500 duration-300 hover:ring-4 hover:ring-theme-200 group-hover/section:bg-theme-800"
              >
                <svg-icon
                  class="flex w-6 p-1 text-theme-500 group-hover/section:text-theme-50"
                  src="assets/icons/icon-trash.svg"
                ></svg-icon>
              </button>
            </div>
          </div>

          <ng-container *ngIf="section.id">
            <div
              *ngIf="!section?.elementos?.length; else hasElement"
              class="flex h-full flex-col items-center justify-center"
            >
              <p class="py-10 text-md text-theme-500" translate>trilhas.estudio.trilha.sem-elementos</p>
              <div class="flex items-center justify-end">
                <button
                  type="button"
                  app-icon-button
                  translate
                  (click)="onOpenElementModal(section.id, section.elementos.length)"
                  class="group mx-2 border border-theme-800 text-theme-800 shadow-md duration-300 hover:bg-theme-800 hover:text-theme-contrast"
                >
                  <svg-icon
                    class="mr-2 flex w-5 justify-center text-theme-800 group-hover:text-theme-contrast"
                    src="assets/icons/icon-plus.svg"
                  ></svg-icon>
                  trilhas.estudio.trilha.elemento
                </button>
              </div>
            </div>

            <ng-template #hasElement>
              <div class="mt-5 w-full">
                <div cdkDropList (cdkDropListDropped)="dropElement($event, i)" class="flex w-full flex-col">
                  <div
                    #item
                    *ngFor="let element of section.elementos; let isFirst = first; let isLast = last"
                    cdkDrag
                    class="group/element relative z-10 mb-2"
                  >
                    <div
                      class="rounded-2xl px-2 py-2 shadow-lg duration-300 group-odd/element:bg-white group-even/element:bg-theme-100 group-hover/element:bg-theme-50"
                    >
                      <div class="flex justify-between">
                        <div class="flex items-center gap-3">
                          <div class="px-5 md:hidden">
                            <svg-icon
                              *ngIf="!isFirst"
                              (click)="moveUpElement(element, i)"
                              class="flex w-6 p-1 font-light text-theme-500 duration-300 hover:text-theme-950"
                              src="assets/icons/icon-arrow-up.svg"
                            ></svg-icon>
                            <svg-icon
                              *ngIf="!isLast"
                              (click)="moveDownElement(element, i)"
                              class="flex w-6 p-1 font-light text-theme-500 duration-300 hover:text-theme-950"
                              src="assets/icons/icon-arrow-down.svg"
                            ></svg-icon>
                          </div>
                          <svg-icon
                            cdkDragHandle
                            src="assets/icons/icon-grid.svg"
                            class="mr-1 hidden w-8 cursor-move p-1 text-theme-500 md:flex"
                          ></svg-icon>
                          <svg-icon
                            [src]="icon(element?.tipo)"
                            class="mr-5 flex w-7 group-hover/tipos:text-white md:mr-3"
                            [ngClass]="textIcon(element?.tipo)"
                          >
                          </svg-icon>
                          <span class="px-1 text-md text-theme-950">{{ element?.titulo }}</span>
                        </div>
                        <div class="flex items-center md:mr-5">
                          <div
                            class="m-3 flex items-center gap-5 duration-300 group-hover/element:opacity-100 md:opacity-0"
                          >
                            <button
                              app-tooltip
                              [tooltip]="'geral.editar' | translate"
                              (click)="onOpenElementModal(null, null, element)"
                            >
                              <svg-icon
                                class="flex w-6 text-theme-500 duration-300 hover:text-theme-950"
                                src="assets/icons/icon-pencil.svg"
                              ></svg-icon>
                            </button>
                            <button
                              app-tooltip
                              [tooltip]="'geral.excluir' | translate"
                              (click)="onDeleteElement(element, i)"
                            >
                              <svg-icon
                                class="flex w-6 text-theme-500 duration-300 hover:text-theme-950"
                                src="assets/icons/icon-trash.svg"
                              ></svg-icon>
                            </button>
                          </div>
                          <svg-icon
                            [ngClass]="{
                              'text-base-status-success-500 !opacity-100 duration-300 hover:text-theme-950':
                                !!element.evento_historico_curso?.length,
                              'text-base-gray-200 !opacity-100 hover:text-base-gray-300':
                                !element.evento_historico_curso?.length,
                            }"
                            app-tooltip
                            [tooltip]="
                              (!!element.evento_historico_curso?.length
                                ? 'trilhas.evento.publicado'
                                : 'trilhas.evento.nao-publicado'
                              ) | translate
                            "
                            class="flex w-9 p-1"
                            src="assets/icons/icon-checked-circle.svg"
                          ></svg-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>
